import {Block, Socials} from "../../components/";
import styles from "../../components/Socials/Socials.module.scss";
import img from '../../resources/finish.jpg';

const text = "";

export const SberThirdBlock = () => {
    return (
        <Block name="box-blue-12" title="" desc={text}>
            <div className={styles.wrap}>
                <img src={img} className={styles.img} alt="Финал"/>
                <div className={styles.text}>Поделись открыткой в соцсетях и увеличь свои шансы на победу</div>
                <Socials share={true} className={styles.finish} icons={true}/>
            </div>
        </Block>
    )
}